import type { AppRouteModule } from "/@/router/types";

import { LAYOUT } from "/@/router/constant";

const article: AppRouteModule = {
  path: "/article",
  name: "Article",
  component: LAYOUT,
  redirect: "/article/index",
  meta: {
    hideChildrenInMenu: false,
    icon: "ant-design:home-outlined",
    title: "软文自动发布",
    orderNo: 1,
  },
  children: [
    {
      path: "index",
      name: "ArticleAuto",
      component: () => import("/@/views/articleAuto/index.vue"),
      meta: {
        title: "软文字段预发布",
        hideMenu: false,
      },
    },
    {
      path: "public",
      name: "ArticlePublic",
      component: () => import("/@/views/articleAuto/public.vue"),
      meta: {
        title: "软文字段发布",
        hideMenu: false,
      },
    },
    {
      path: "edit",
      name: "ArticleEdit",
      component: () => import("/@/views/articleAuto/edit.vue"),
      meta: {
        title: "软文修改",
        hideMenu: true,
      },
    },
    {
      path: "preEdit",
      name: "PreArticleEdit",
      component: () => import("/@/views/articleAuto/preEdit.vue"),
      meta: {
        title: "预发布软文修改",
        hideMenu: true,
      },
    },
    {
      path: "manualEdit",
      name: "ManualEdit",
      component: () => import("/@/views/articleAuto/manualEditing.vue"),
      meta: {
        title: "软文手动编辑发布",
      },
    },
  ],
};

export default article;
